import type { StyleElements } from "replo-runtime/shared/utils/styles";
import type { CustomPropsRecord } from "schemas/component";
import type { ComponentConfig } from "../../components";

import { convertToLegacyProps } from "../../../shared/utils/props";

function getConfigurableProps(): CustomPropsRecord {
  return {
    _products: {
      type: "products",
      name: "Products",
      description: "A list of Shopify products to include.",
      defaultValue: [],
    },
  };
}

const styleElements = {
  root: {
    defaultStyles: {
      display: "flex",
    },
  },
} as const satisfies StyleElements;

const config = {
  renderData: {
    customProps: convertToLegacyProps(getConfigurableProps()),
    newInstancesUseNumbering: true,
    allowsLayoutModification: true,
    acceptsArbitraryChildren: () => true,
    isAlwaysDynamic: true,
    canvasIndicatorDragDirections: [],
    canContainChildren: true,
    showComponentControlsFromChildren: true,
    dynamicItemsPropName: "_products",
    styleElements,
  },
} satisfies ComponentConfig;

export default config;
